/* owner 2026-10-06: shop-styled loading indicator, only for waits longer than 2 s.
   Shows a thin green progress bar along the top plus a small "Loading…" pill with the SZ monogram.
   Covers: page-to-page navigation (links, form submits) and same-origin fetch/XHR (add to bag, cart,
   search, infinite scroll). Skips app proxies (/apps/ — Pips has its own typing state), analytics and
   keepalive beacons. Manual use: SZLoader.begin() / SZLoader.end(). Auto-hides after 30 s. */
(function () {
  if (window.SZLoader) return;
  var DELAY = 2000, CAP = 30000;
  var me = document.currentScript, mark = me && me.getAttribute('data-mark');
  var el, pending = 0, timer = null, capTimer = null, navTimer = null;

  function build() {
    if (el) return el;
    el = document.createElement('div');
    el.className = 'sz-loader'; el.setAttribute('role', 'status'); el.setAttribute('aria-live', 'polite'); el.hidden = true;
    el.innerHTML = '<div class="sz-loader__bar" aria-hidden="true"></div>' +
      '<div class="sz-loader__pill"><span class="sz-loader__mark" aria-hidden="true"' + (mark ? ' style="--sz-loader-mark:url(\'' + mark + '\')"' : '') + '></span><span class="sz-loader__text">Loading…</span></div>';
    document.body.appendChild(el);
    return el;
  }
  function show() { build().hidden = false; requestAnimationFrame(function () { el.classList.add('is-on'); }); clearTimeout(capTimer); capTimer = setTimeout(hideAll, CAP); }
  function hide() { if (!el) return; el.classList.remove('is-on'); setTimeout(function () { if (!el.classList.contains('is-on')) el.hidden = true; }, 300); }
  function hideAll() { pending = 0; clearTimeout(timer); clearTimeout(navTimer); timer = navTimer = null; hide(); }
  function begin() { pending++; if (pending === 1 && !timer) timer = setTimeout(function () { timer = null; if (pending > 0) show(); }, DELAY); }
  function end() { pending = Math.max(0, pending - 1); if (!pending) { clearTimeout(timer); timer = null; if (!navTimer) hide(); } }
  // JS-BAG-1014: the timer is nulled when it fires, so end() can hide the bar again afterwards.
  function nav() { clearTimeout(navTimer); navTimer = setTimeout(function () { navTimer = null; show(); }, DELAY); }

  function tracked(url, opts) {
    try {
      var u = new URL(url, location.href);
      if (u.origin !== location.origin) return false;
      if (/^\/(apps|api\/collect|\.well-known|cdn|checkouts\/internal)\b|web-pixels|monorail|\/sf_private_access/.test(u.pathname)) return false;
      if (opts && opts.keepalive) return false;
      return true;
    } catch (e) { return false; }
  }

  if (window.fetch) {
    var f = window.fetch;
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && (input.url || input.href)) || '';
      if (!tracked(url, init)) return f.apply(this, arguments);
      begin();
      return f.apply(this, arguments).then(function (r) { end(); return r; }, function (e) { end(); throw e; });
    };
  }
  var XO = XMLHttpRequest.prototype.open, XS = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (m, url) { this._szTrack = tracked(url); return XO.apply(this, arguments); };
  XMLHttpRequest.prototype.send = function () {
    if (this._szTrack) { begin(); var x = this, done = false; this.addEventListener('loadend', function () { if (!done) { done = true; end(); } }); }
    return XS.apply(this, arguments);
  };

  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest && e.target.closest('a[href]'); if (!a) return;
    if (a.target && a.target !== '_self') return; if (a.hasAttribute('download')) return;
    var u; try { u = new URL(a.href, location.href); } catch (err) { return; }
    if (!/^https?:$/.test(u.protocol) || u.origin !== location.origin) return;
    if (u.pathname === location.pathname && u.search === location.search && u.hash) return;
    // JS-BAG-1014: links opened in place by later listeners (the Bag panel, the Account sheet) call preventDefault
    // AFTER this capture-free document listener has run, so check once the event has finished, as submit does.
    // Before, the bar and "Loading…" pill sat over the bag panel until the 30 s cap.
    setTimeout(function () { if (!e.defaultPrevented) nav(); }, 0);
  });
  document.addEventListener('submit', function (e) {
    var form = e.target; if (form.target && form.target !== '_self') return;
    setTimeout(function () { if (!e.defaultPrevented) nav(); }, 0);
  });
  window.addEventListener('pageshow', hideAll);
  window.addEventListener('pagehide', function () { clearTimeout(capTimer); });

  window.SZLoader = { begin: begin, end: end, show: show, hide: hideAll };
})();
